export default function addScriptTag(src, async = true, id) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = async;
  script.src = src;
  script.id = id;

  document.body.appendChild(script);
}
